export function tabview(ctx) {
    return {
        properties: {
            btn_pos: 1,
            text_font: 32,
        },
        styles: {
            // text_color isn't wired anywhere (HaspTabview.js hardcodes tab
            // label fill to 'white' — see its render code) but kept here,
            // not dropped, to mirror the previous (equally inert) flat value.
            main: { ...ctx.pretty, radius: 0, border_width: 0, text_color: ctx.SCR_TEXT },
            // indicator = tabview_indic (primary colour)
            indicator: { bg_color: ctx.primary },
            // items/tab-bg = tabview_btns_bg
            items: { bg_color: ctx.SCR_GRAD, border_color: 'black', border_width: 0, radius: 0 },
        },
    };
}
